@import '../../../theme.scss';

verdocs-search-tabs {
  font-family: $verdocs-primary-font;
  display: block;
}
